import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import QuestionTabs from './QuestionTabs';
import { Col } from 'reactstrap';
import Avatar from '@material-ui/core/Avatar';
import EditIcon from '@material-ui/icons/Edit';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';



export default function QuestionStats(props) {
    useEffect(() => {

        return () => null;
    }, [props.clientResponses]);

    const { clientResponses, selectedQuestion, sendResponse, orderList,questionPresentParticipants,
        clear, textEditing, questionName, active, removeClientData, eventId, user, clientList, selectedOptions } = props;
    let orderListFiltered = Array.from(orderList);

    if (selectedQuestion.personType && selectedQuestion.personType > 0) {
        orderListFiltered = orderListFiltered.filter(a => {
            return !a.personTypes.includes(selectedQuestion.personType);
        })
    }
    let totalAnswerCount = 0
    for (const a of clientResponses) {
        totalAnswerCount += 1 * a.answerWeight;
    } 
    const answered = orderListFiltered.filter(a => {
        return props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length
    const notAnsweredButPresent = questionPresentParticipants.filter(a => {
        return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length
    const notAnswered = orderListFiltered.filter(a => {
        return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
    }).length


    return (
        <div>
            <div className="inline-flex" style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-6 text-left secondary-text">
                    <SystemLabel name="Participated" />
                </Col>
                <Col className="text-center primary-text">
                    {answered}
                </Col>
                <Col></Col>
                <Col className="text-center primary-text">
                    {questionPresentParticipants.length > 0 ? Math.round((answered / questionPresentParticipants.length) * 100) + '%' : ''}
                </Col>
                <Col className="text-center primary-text">
                    {clientList.length > 0 ? Math.round((answered / orderListFiltered.length) * 100) + '%' : ''}
                </Col>
            </div>
            {/* <div className="inline-flex" style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-4 text-left secondary-text">
                    <SystemLabel name="NoneParticipatedButPresent" />
                </Col>
                <Col className="col-4 text-center primary-text">
                    {notAnsweredButPresent}
                </Col>
                <Col></Col>
                <Col className="col-4 text-center primary-text">
                    {clientList.length > 0 ? (Math.round((notAnsweredButPresent / questionPresentParticipants.length) * 100)) + '%' : ''}
                </Col>
            </div> */}
            <div className="inline-flex" style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-6 text-left secondary-text">
                    <SystemLabel name="NoneParticipated" />
                </Col>
                <Col className="text-center primary-text">
                    {notAnswered}
                </Col>
                <Col></Col>
                <Col className="text-center primary-text">
                    {questionPresentParticipants.length > 0 ? Math.round((notAnsweredButPresent / questionPresentParticipants.length) * 100) + '%' : ''}
                </Col>
                <Col className="text-center primary-text">
                    {clientList.length > 0 ? (Math.round((notAnswered / orderListFiltered.length) * 100)) + '%' : ''}
                </Col>
            </div>
            <div className="inline-flex" style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                <Col className="col-6 text-left secondary-text">
                    <SystemLabel name="Options" />
                </Col>
                <Col className="text-center secondary-text">
                    <SystemLabel name="Count" />
                </Col>
                <Col className="text-center secondary-text">
                    <SystemLabel name="Precentage" />
                </Col>
                <Col className="text-center secondary-text">
                    <SystemLabel name="Entitled" />
                </Col>
                <Col className="text-center secondary-text">
                    <SystemLabel name="Total" />
                </Col>
            </div>
            <div className="dark-list" style={{ maxHeight: 'calc(100vh - 471px)', minHeight: 'calc(100vh - 471px)', overflowY: 'auto' }}>
                {selectedQuestion.questionOption.map((qo, i) => {

                    return <div key={i} className="inline-flex" style={{ width: '100%', padding: '15px 10px', display: 'inline-flex' }}>
                        <Col className="col-6 text-left primary-text">
                            {qo.questionOptionLanguage.find(
                                ql => ql.languageCode == props.lang
                            ).label}
                        </Col>
                        <ClientResponseCount questionPresentParticipants={questionPresentParticipants}  orderList={orderListFiltered} clientResponses={clientResponses} questionOption={qo} totalAnswerCount={totalAnswerCount} />
                    </div>
                })}
            </div>

        </div>
    );
}

function ClientResponseCount({ clientResponses, questionOption, orderList, totalAnswerCount, questionPresentParticipants = [] }) {

    var answerCount = 0
    for (const a of clientResponses.filter(cr => cr.answer == questionOption.questionOptionId.toString())) {
        answerCount += 1 * a.answerWeight;
    } 
    // const responses = clientResponses.filter(cr => cr.answer == questionOption.questionOptionId.toString()).length;
    var badgeNoList = [];
    orderList.map(ia => {
        badgeNoList.push(ia.badgeNo);
    })
    const answerPersons = [];
    clientResponses.filter(cr => cr.answer == questionOption.questionOptionId.toString() && badgeNoList.includes(cr.clientKey)).map(cr => {
        if (!answerPersons.includes(cr.clientKey)) {
            answerPersons.push(cr.clientKey);
        }
    });
    return <React.Fragment>
        <Col className="text-center primary-text">
            {answerCount}
        </Col>
        <Col className="text-center primary-text">
            {totalAnswerCount > 0 ? Math.round(answerCount / totalAnswerCount * 100) + '%' : ""}
        </Col>
        <Col className="text-center primary-text">
            {answerPersons.length > 0 && questionPresentParticipants.length > 0 ? Math.round(answerPersons.length / questionPresentParticipants.length * 100) + '%' : '0%'}
        </Col>
        <Col className="text-center primary-text">
            {answerPersons.length > 0 && orderList.length > 0 ? Math.round(answerPersons.length / orderList.length * 100) + '%' : '0%'}
        </Col>
    </React.Fragment>
}